import SortRoundedIcon from "@mui/icons-material/SortRounded";

export const sort = (props) => {
  return <SortRoundedIcon {...props} />;
};
